/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.TranslationsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type TranslationKey =
  | 'SUPPORT_SPACE_DISPLAY_NAME'
  | 'SUPPORT_SPACE_PAGE_TITLE'
  | 'SUPPORT_SPACE_LISTINGS_PAGE_TICKET_PROPERTIES'
  | 'SUPPORT_SPACE_DETAIL_PAGE_TICKET_PROPERTIES'
  | 'SUPPORT_SPACE_FORM_MENU_TEXT'
  | 'SUPPORT_SPACE_FORM_HEADER_TEXT'
  | 'REFERENCE_SPACE_EXAMPLE'
  | 'REFERENCE_SPACE_DISPLAY_NAME'
  | 'REFERENCE_SPACE_WELCOME_TEXT'
  | 'REFERENCE_SPACE_TABLE_CELL_ONE'
  | 'REFERENCE_SPACE_TABLE_CELL_TWO'
  | 'HOME_SPACE_DISPLAY_NAME'
  | unhandledEnumCase;

export const ConsentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export type ConsentError = {
  reason: ConsentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.ConsentError';
} & { '@type'?: 'CONSENT' };

export const NotificationErrorTypename =
  'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export type NotificationError = {
  reason: NotificationErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.NotificationError';
} & { '@type'?: 'NOTIFICATION' };

export const PortalAuthErrorTypename =
  'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
} & { '@type'?: 'AUTH' };

export const PortalPublicRpcErrorDiscriminantKey = '@type';
export type PortalPublicRpcError =
  | PortalAuthError
  | NotificationError
  | ConsentError
  | SettingsError
  | SupportPortalError
  | TranslationsError
  | TrackEventError;

export const SettingsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export type SettingsError = {
  reason: SettingsErrorReason;
  passwordErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SettingsError';
} & { '@type'?: 'SETTINGS' };

export const SupportPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export type SupportPortalError = {
  reason: SupportPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
} & { '@type'?: 'SUPPORT_PORTAL' };

export const TrackEventErrorTypename =
  'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export type TrackEventError = {
  reason: TrackEventErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.TrackEventError';
} & { '@type'?: 'TRACK_EVENT' };

export type ConsentErrorReason =
  | 'CONSENT_LABELS_NOT_FOUND'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type NotificationErrorReason =
  | 'NOTIFICATION_NOT_FOUND'
  | 'INVALID_NOTIFICATION_TYPE'
  | 'MISSING_PORTAL_ID'
  | 'INVALID_NOTIFICATION_NAME'
  | 'INVALID_TARGET'
  | 'PORTAL_INSTANCE_NOT_FOUND'
  | 'HUBSPOT_NOTIFICATION_SEND_FAILED'
  | unhandledEnumCase;

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | 'WRONG_HUBLET'
  | unhandledEnumCase;

export type SettingsErrorReason =
  | 'MISSING_REQUIRED_FIELD'
  | 'CONTACT_NOT_FOUND'
  | 'FILE_TOO_LARGE'
  | 'UNSUPPORTED_FILE_TYPE'
  | 'WRONG_CURRENT_PASSWORD'
  | 'INVALID_PASSWORD'
  | 'SAME_PASSWORD'
  | 'PASSWORD_LEAKED'
  | 'PASSWORDS_DO_NOT_MATCH'
  | 'CURRENT_PASSWORD_REQUIRED'
  | 'INVALID_PREFERRED_LANGUAGE'
  | 'FIELD_TOO_LONG'
  | 'PROFILE_EDITING_DISABLED'
  | 'RATE_LIMITED'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type SupportPortalErrorReason =
  | 'SETTINGS_NOT_FOUND'
  | 'TICKET_NOT_FOUND'
  | 'THREAD_NOT_FOUND'
  | 'CONTACT_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | 'INVALID_MESSAGE_PUBLISH'
  | 'INVALID_TICKET_ACTION'
  | 'INVALID_REQUEST'
  | unhandledEnumCase;

export type TrackEventErrorReason = 'EVENT_NOT_TRACKABLE' | unhandledEnumCase;

export type ListPortalTranslationsRequest = {
  locale?: string;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
  tolerateInstanceAccessDenied?: boolean;
};

export type ListPortalTranslationsResponse = {
  translations: Default<TranslationEntry[]>;
  aiTranslationsEnabled?: boolean;
  domainLanguage?: string;
};

export type TranslationEntry = {
  key: TranslationKey;
  subKey: Default<string>;
  value: string;
};

export const TranslationsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export type TranslationsError = {
  reason: TranslationsErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
} & { '@type'?: 'TRANSLATIONS' };

export type TranslationsErrorReason =
  | 'MISSING_LOCALE'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type ListPortalTranslationsRequestType =
  Requestify<ListPortalTranslationsRequest>;
export type ListPortalTranslationsResponseType = ListPortalTranslationsResponse;
export type ListPortalTranslationsErrorType = PortalPublicRpcError &
  HubspotMetadata;
export const listPortalTranslationsRpc: ChirpAvroRpcDetails<
  ListPortalTranslationsRequestType,
  ListPortalTranslationsResponseType,
  ListPortalTranslationsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.TranslationsRpc',
  rpcName: 'listPortalTranslations',
  auth: 'external',
  fingerprint: 'ysKdGlKfZI9Q2giwm8Nfh4BUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
